// TODO enable eslint
/* eslint-disable react/sort-comp */
import React from "react"
import cn from "classnames"
import debounce from "lodash/debounce"
import GlobalEscapeHandle from "src/components/GlobalEscapeHandle"
import NewEventForm from "src/containers/Calendar/components/NewEventForm"
import styles from "./styles.css"
import { BLANK_ITEM_ID } from "../../constants"

function stringify(value) {
  return typeof value === `string` ? value : `${value}px`
}

const AREA_PADDING = 24
const EVENT_MODAL_GAP = 10

export default class EventCard extends React.Component {
  modalElement = null

  eventElement = null

  areaElement = null

  labelElement = null

  state = {
    hidden: true, // Hidden before properly placed
    positionXShift: `50%`,
    positionYShift: `50%`,
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.setEventElement(document.querySelector(`[eventid="${BLANK_ITEM_ID}"]`))
    this.setLabelElement(
      document.querySelector(`[eventid="${BLANK_ITEM_ID}"] span`),
    )
    this.setAreaElement(document.querySelector(`.rct-scroll`))
  }

  componentDidMount() {
    window.addEventListener(`resize`, this.onWindowChange)

    // Delay position calc to take scrollbar disappear into account
    setTimeout(this.recalculateModalPosition)
  }

  setAreaElement = element => {
    this.areaElement = element
  }

  setModalElement = element => {
    this.modalElement = element
  }

  setEventElement = element => {
    this.eventElement = element
  }

  setLabelElement = element => {
    this.labelElement = element
  }

  // Recalculate and apply modal window position
  recalculateModalPosition = () => {
    if (this.modalElement && this.eventElement) {
      const {
        left: eventLeft,
        right: eventRight,
        top: eventTop,
      } = this.eventElement.getBoundingClientRect()
      const {
        width: modalWidth,
        height: modalHeight,
      } = this.modalElement.getBoundingClientRect()
      const { right: labelRight } = this.labelElement.getBoundingClientRect()
      const { left: areaLeft } = this.areaElement.getBoundingClientRect()
      const areaRight = window.innerWidth
      const areaBottom = window.innerHeight

      const getXPosition = () => {
        const isInsideAreaX = xCoordinate =>
          xCoordinate >= areaLeft + AREA_PADDING &&
          xCoordinate <= areaRight - AREA_PADDING
        const canPutRight = isInsideAreaX(
          eventRight + EVENT_MODAL_GAP + modalWidth,
        )
        const canPutLeft = isInsideAreaX(
          eventLeft - EVENT_MODAL_GAP - modalWidth,
        )
        const canPutOn = isInsideAreaX(labelRight + modalWidth)

        if (canPutRight) {
          return eventRight + EVENT_MODAL_GAP
        }
        if (canPutLeft) {
          return eventLeft - EVENT_MODAL_GAP - modalWidth
        }
        if (canPutOn) {
          return labelRight + EVENT_MODAL_GAP
        }
        return `50%`
      }

      const getYPosition = () => {
        const deltaY = eventTop + modalHeight - areaBottom + AREA_PADDING
        return eventTop - (deltaY > 0 ? deltaY : 0)
      }

      this.setState({
        hidden: false,
        positionXShift: getXPosition(),
        positionYShift: getYPosition(),
      })
    }
  }

  onWindowChange = debounce(this.recalculateModalPosition, 100)

  componentWillUnmount() {
    window.removeEventListener(`resize`, this.onWindowChange)
  }

  handleClose = () => {
    const { onClose } = this.props

    onClose()
  }

  render() {
    const { hidden, positionXShift, positionYShift } = this.state

    return (
      <div>
        <GlobalEscapeHandle onEscapePress={this.handleClose} />
        <div
          className={cn(styles.cardOverlay, { [styles.hidden]: hidden })}
          onClick={this.handleClose}
        />
        <div
          className={cn(styles.Card, { [styles.hidden]: hidden })}
          ref={this.setModalElement}
          style={{
            left: stringify(positionXShift),
            top: stringify(positionYShift),
          }}
        >
          <NewEventForm {...this.props} />
        </div>
      </div>
    )
  }
}
